import type { ExtendedConstraints, CapabilityConfig } from '../../types';
import { hasOnlyKeysFromSet } from '../../utils';

export const id = 'navigation-interception';

export enum Actions {
  Add = 'navigation-interception:add',
  Remove = 'navigation-interception:remove',
}

export enum Events {}

export type Config = CapabilityConfig & {
  type: typeof id;
};

export enum StatusIcon {
  Check = 'check',
  Negative = 'negative',
  Alert = 'alert',
  Informative = 'informative',
  Spinner = 'spinner',
}

export type NavigationAddPayload = {
  title: string;
  description: string;
  stayButtonText: string;
  leaveButtonText: string;
  statusIcon?: StatusIcon | undefined;
  id: string;
  allowClientSideNavigation?: boolean;
};

export type NavigationRemovePayload = Pick<NavigationAddPayload, 'id'>;

export type Constraints = ExtendedConstraints<{
  actions: Actions;
  config: Config;
  actionPayloadTuple:
    | [Actions.Add, NavigationAddPayload]
    | [Actions.Remove, NavigationRemovePayload];
}>;

const VALID_CONFIG_KEYS = ['type'] as const;
export function isValidConfig(config: CapabilityConfig): config is Config {
  if (!hasOnlyKeysFromSet(config, VALID_CONFIG_KEYS)) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  return true;
}
